import { SunCompassIcon } from './SunCompassIcon';

/**
 * author: Michael Irigoyen
 * id 1F513D40-444E-475D-9C1F-E5A95CE61A02
 * name sun-compass
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sun-compass.svg
 * tags
 * - Weather 
 * - Home Automation 
 * - Navigation 
 */
export const SolarAsimuthIcon = SunCompassIcon;
export default SolarAsimuthIcon